import TemplateView from '../../../../../js/TemplateView'
import FeedNameCell from './cells/FeedNameCell'
import FeedDetailsCell from './cells/FeedDetailsCell'
import FeedUrlCell from './cells/FeedUrlCell'
import {getCopyDialog} from '../../dialogs/CopyLinkDialog'

export default class SharedFeedsRow extends TemplateView {
    constructor({
        feed,
        getFeedUrl,
    }) {
        super()

        this.params = {
            id: feed.id,
        }

        this.state = {
            name: feed.name,
            createdDate: feed.createdDate,
            creator: feed.creator,
            editedDate: feed.editedDate,
            editor: feed.editor,
            leaveTypes: feed.leaveTypes,
            userSelection: feed.sharedUsersSelection,
        }

        this.callbacks = {
            getFeedUrl,
        }

        this.onStateDeeplyChanged(() => {
            this.getEl().empty()
            this._update()
        })
    }

    templateHtml() {
        return `<div class='feedRow sharedFeeds'/>`
    }

    _update() {
        new FeedNameCell({
            name: this.state.name,
            createdDate: this.state.createdDate,
            creator: this.state.creator,
            editedDate: this.state.editedDate,
            editor: this.state.editor,
        }).init(this.getEl())

        new FeedDetailsCell({
            leaveTypes: this.state.leaveTypes,
            userSelection: this.state.userSelection,
        }).init(this.getEl())

        this.copyDialog = getCopyDialog()
        this.feedUrlCell = new FeedUrlCell({
            onClick: ($targetEl) => {
                this.feedUrlCell.setState({loading: true})
                this.callbacks.getFeedUrl(
                    this.params.id,
                    (linkForCopy) => {
                        this.copyDialog.setState({linkForCopy})
                        this.copyDialog.showAt($targetEl, () => this.feedUrlCell.setState({active: false}))
                        this.feedUrlCell.setState({
                            active: true,
                            loading: false,
                        })
                    },
                    () => this.feedUrlCell.setState({loading: false})
                )
            }
        }).init(this.getEl())
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/SharedFeedsRow.js